module.exports = __webpack_public_path__ + "static/assets/db426166326d7895a3b09f3ac8040616.png";